import { useState, useEffect } from "react";
import { ScheduledEventsQueries } from "../../../../../../requests/queries/ScheduledEvents.js";
import ScheduledEventPicker from "../../components/picker/ScheduledEventPicker";
import ColorPicker from "../../components/picker/ColorPicker";

export default function ScheduledCellProperties({ cell, onChange }) {

    const [events, setEvents] = useState([]);
    const [newEvent, setNewEvent] = useState(null);

    const [currentEvent, setCurrentEvent] = useState(null);

    const handleDeleteEvent = async (eventId) => {
        await ScheduledEventsQueries.deleteEvent(eventId);
        setEvents(events.filter((event) => event.id !== eventId));
        setCurrentEvent(null);
        setNewEvent(null);
    }

    const handleSaveEvent = async (event) => {
        try {
            if (event.id && events.find((e) => e.id === event.id)) {
                const updatedEvent = await ScheduledEventsQueries.updateEvent(event.id, event);
                setEvents(events.map((e) => e.id === event.id ? updatedEvent : e));
                setCurrentEvent(null);
                setNewEvent(null);
            } else {
                const createdEvent = await ScheduledEventsQueries.createEvent(event);
                setEvents([...events, createdEvent]);
                setNewEvent(null);
                setCurrentEvent(null);
            }
        } catch (error) {
            console.error("Erreur lors de la sauvegarde de l'événement:", error);
        }
    }

    useEffect(() => {
        const fetchEvents = async () => {
            if (!cell.schedule_cell_id) return;
            const events = await ScheduledEventsQueries.getByScheduleCellId(cell.schedule_cell_id);
            setEvents(events);
        }
        fetchEvents();
    }, [cell.schedule_cell_id]);

    return (
        <div className="property-section">
            <div className="property-section-title">Scheduled</div>
            <div className="property-row">
                <div className="property-label">Template name</div>
                <select className="property-input property-input-small" value={cell.template_name} onChange={(e) => onChange(cell.id, {template_name: e.target.value, type: cell.type})}>
                    <option value="default">Default</option>
                    <option value="corporate">Entreprise</option>
                    <option value="neon">Neon</option>
                    <option value="nature">Nature</option>
                    <option value="retro">Rétro</option>
                    <option value="minimal">Minimal</option>
                </select>
            </div>
            <div className="property-row">
                <div className="property-label">Nouvel événement</div>
                <button className="property-button-add" onClick={() => setNewEvent({title: '', description: '', location: '', start_time: '', end_time: '', logo_uri: ''})}>+</button>
            </div>
            <div className="property-container">
                <div className="property-label">Modifier un événement</div>
                {
                    events.map((event) => {
                        return (
                            <div className="property-row" key={event.id}>
                                <div className="property-label">{event.title}</div>
                                <button className="property-button-edit" onClick={() => setCurrentEvent(event)}>Modifier</button>
                                <button className="property-button-delete" onClick={() => handleDeleteEvent(event.id)}>-</button>
                            </div>
                        )
                    })
                }
            </div>
            {
                currentEvent && (
                    <ScheduledEventPicker isOpen={true} onClose={() => setCurrentEvent(null)} event={currentEvent} scheduleCellId={cell.schedule_cell_id} onSave={handleSaveEvent}/>
                )
            }
            {
                newEvent && (
                    <ScheduledEventPicker isOpen={true} onClose={() => setNewEvent(null)} event={newEvent} scheduleCellId={cell.schedule_cell_id} onSave={handleSaveEvent}/>
                )
            }
            <div className="property-section">
                <div className="property-section-title">Styles template</div>
                <div className="property-row">
                    <div className="property-label">Couleur de fond</div>
                    <ColorPicker value={cell.styles_properties?.background_color || '#ffffff'} onChange={(color) => onChange(cell.id, {styles_properties: {...cell.styles_properties, background_color: color}, type: cell.type})}/>
                </div>
                <div className="property-row">
                    <div className="property-label">Couleur primaire</div>
                    <ColorPicker value={cell.styles_properties?.primary_color || '#000000'} onChange={(color) => onChange(cell.id, {styles_properties: {...cell.styles_properties, primary_color: color}, type: cell.type})}/>
                </div>
                <div className="property-row">
                    <div className="property-label">Couleur secondaire</div>
                    <ColorPicker value={cell.styles_properties?.secondary_color || '#000000'} onChange={(color) => onChange(cell.id, {styles_properties: {...cell.styles_properties, secondary_color: color}, type: cell.type})}/>
                </div>
                <div className="property-row">
                    <div className="property-label">Couleur des textes</div>
                    <ColorPicker value={cell.styles_properties?.text_color || '#000000'} onChange={(color) => onChange(cell.id, {styles_properties: {...cell.styles_properties, text_color: color}, type: cell.type})}/>
                </div>
                <div className="property-row">
                    <div className="property-label">Couleur des textes (muet)</div>
                    <ColorPicker value={cell.styles_properties?.text_muted || '#000000'} onChange={(color) => onChange(cell.id, {styles_properties: {...cell.styles_properties, text_muted: color}, type: cell.type})}/>
                </div>
                <div className="property-row">
                    <div className="property-label">Police de caractères</div>
                    <input className="property-input property-input-small" type="text" placeholder="Inter, sans-serif" value={cell.styles_properties?.font_family || ''} onChange={(e) => onChange(cell.id, {styles_properties: {...cell.styles_properties, font_family: e.target.value}, type: cell.type})}/>
                </div>
            </div>
        </div>
    )
}